interface DataAttribute {
	key: string;
	value: string;
}
interface Script {
	id: string;
	strategy: string;
	src?: string;
	inline?: string;
	dataAttributes: DataAttribute[];
}
interface OrderedScriptProps {
	scripts: Script[];
}

export const OrderedScripts = ({ scripts }: OrderedScriptProps) => {
	return (
		<>
			{scripts.map((script) => (
				<script
					key={script.id}
					id={script.id}
					defer={true}
					{...(script.src && { src: script.src })}
					{...(script.inline && { dangerouslySetInnerHTML: { __html: script.inline } })}
					{...(script.dataAttributes?.length && script.dataAttributes.reduce((data, item) => ({ ...data, [`data-${item.key}`]: item.value }), {}))}
				></script>
			))}
		</>
	);
};
